import {chain} from "../../utils/fs";
import {sortMulti} from "../../utils/collections";
import { cs } from "../../react/chain-services";
import {UseState} from "../../react/use-state";
import {SearchableSelect} from "./searchable-select";
import {Load} from "../../react/load";
import {consumeContext} from "../../react/context";

export const userSearch = ( textField, idAgent, idBranch='', filterByUserLevel=0, agentBranch='' ) => cs(
    consumeContext("apis"),
    ["state", ({}, next) => UseState({
        defaultValue: idAgent ? {
            type: "agent",
            value: {
                branchId: idBranch,
                agentId: idAgent,
            },
        } : {
            type: "none",
            value: {
                branchId: idBranch,
            },
        },       
        next,
    })],
    ["agentList", ({state, apis}, next) => {
        return Load({
            _key: idBranch,
            fetch: () => {
                if( idBranch && idAgent && agentBranch && agentBranch != idBranch ){
                    state.change((s) => ({
                        type: "none",
                        value: {
                            branchId: idBranch,
                        },
                    }));
                    textField.onChange('');
                }
                return apis.next.getAgentList(idBranch, filterByUserLevel)
            },
            next,
        });
    }],
    ({state, agentList, apis})=>{
        return SearchableSelect({
            list: [
                ...chain(
                    agentList || [],
                    (_) => sortMulti(_, [
                        (agent) => agent["agentNameLast"]?.toLowerCase(),
                        (agent) => agent["agentNameFirst"]?.toLowerCase(),
                    ])
                ),
            ],
            getLabel: (agent) => agent.agentNameLast + ", " + agent.agentNameFirst + ` (${agent.idAgent})`,
            placeholder: "Please select a user",
            onSelect: async (agent) => {
                if (!agent) {
                    state.change((s) => ({
                        type: "none",
                        value: {
                            branchId: s.value?.branchId,
                        },
                    }));
                    textField.onChange('');
                } else {
                    state.change((s) => ({
                        type: "agent",
                        value: {
                            branchId: s.value?.branchId,
                            agentId: agent.idAgent,
                        },
                    }));
                    let agentInfo = await apis.next.getAgentById(agent.idAgent);
                    textField.onChange(JSON.stringify({...agentInfo}));
                }
            },
            isSelected: (agent) => state.value.value?.agentId === agent.idAgent,

            searchLabel: "Search a User",
            xdQaName: "SELECT A USER",   
            id: textField.id,                         
        })
    }
);